import * as actionTypes from "../ActionTypes";
import { put, call, takeLatest, takeEvery } from "redux-saga/effects";
import * as api from "./CategoriesAPI";
import { actionUpdateGlobalLoaderSagaAction } from "../GlobalLoader/GlobalLoaderAction";

function* getCategoriesRequestSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.getCategories, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
    } else {
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* saveCategoriesTestimoyRequestSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.saveCategoriesTestimony, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
    } else {
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* updateCategoriesTestimoyRequestSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.updateCategoriesTestimony, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
    } else {
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* readLayoutsRequestSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.readLayout, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
    } else {
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* deleteCategoriesTestimonyRequestSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.deleteCategoriesTestimony, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
    } else {
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* deleteTestimonyRequestSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.deleteTestimony, payload);
    action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
    } else {
    }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

export default function* CategoriesWatcherSaga() {
  yield takeLatest(actionTypes.CATEGORIES_READ_REQUEST, getCategoriesRequestSaga);

  yield takeLatest(
    actionTypes.CATEGORIES_TESTIMONY_SAVE_REQUEST,
    saveCategoriesTestimoyRequestSaga
  );

  yield takeLatest(
    actionTypes.CATEGORIES_TESTIMONY_UPDATE_REQUEST,
    updateCategoriesTestimoyRequestSaga
  );

  yield takeEvery(
    actionTypes.READ_LAYOUTS_REQUEST,
    readLayoutsRequestSaga
  );

  yield takeLatest(
    actionTypes.CATEGORIES_TESTIMONY_DELETE_REQUEST,
    deleteCategoriesTestimonyRequestSaga
  );

  yield takeLatest(actionTypes.TESTIMONY_DELETE_REQUEST, deleteTestimonyRequestSaga);
}
